<template>
  <div>
    <div
      v-if="listSteps.length"
      :class="`tw-flex tw-flex-col ${
        inModalEdit || inModalAdd ? 'tw-gap-[15px]' : 'tw-gap-[25px]'
      } ${
        inModalEdit || inModalAdd
          ? 'step__to__solve__in__modal'
          : 'step__to__solve__out__modal'
      }`"
    >
      <draggable
        :list="listSteps"
        item-key="id"
        :disabled="disable || action?.checklistGroupTemplateId ? true : false"
        handle=".drag-handle"
        @change="changeItem"
      >
        <template #item="{ element, index }">
          <ListStep
            :item="element"
            :index="index"
            :id-item-expand="idItemExpand"
            :in-modal-edit="inModalEdit"
            :in-modal-add="inModalAdd"
            :checklist-group-id="checkListGroupId"
            :action="action.checklistGroupId"
            :is-edit-action="isEditActionTable"
            @change-expand="changeExpand"
            @remove-step="removeStep"
            @handle-update-data="handleUpdateData"
          />
        </template>
      </draggable>
    </div>
    <ButtonAddAnother
      v-if="
        ((inModalEdit && (checkListGroupId || action.checklistGroupId)) ||
          inModalAdd) &&
        !isEditActionTable
      "
      id="addStep"
      :style-button="'!tw-border-transparent !tw-shadow-none'"
      @click="addStep"
    >
      {{
        listSteps.length === 0
          ? getComponentUiText(
              "app-assess-recommendations-edit-action-modal-add-step-to-solve-1",
            )
          : getComponentUiText(
              "app-assess-recommendations-edit-action-modal-add-task-other-1",
            )
      }}</ButtonAddAnother
    >
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, PropType, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import ButtonAddAnother from "@/components/wizard/buttonAddAnother.vue";
import store from "@/store";
import draggable from "vuedraggable";
import {
  getDataChecklistGroupAction,
  getDataChecklistGroupTemplateAction,
} from "@/services/recommend";
import unescape from "lodash/unescape";
import ListStep from "./listStep.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Checklist } from "@/services/apiRoutes/routes";
const props = defineProps({
  inModalAdd: {
    type: Boolean,
    required: false,
    default: false,
  },
  inModalEdit: {
    type: Boolean,
    required: false,
  },
  action: {
    type: Object as PropType<{
      checklistGroupId: string;
      checklistGroupTemplateId: string;
      arraySteps: Array<{
        id: number;
        title: string;
        description: string;
        optional: boolean;
      }>;
      detailSteps: Array<{
        id: number;
        title: string;
        subTitle: Array<{ content: string }>;
        srcImage: string;
      }>;
    }>,
    required: false,
    default: () => ({}),
  },
  checkListGroupId: {
    type: String,
    required: false,
    default: "",
  },
  checkListGroupTemplateId: {
    type: String,
    required: false,
    default: "",
  },
  disable: {
    type: Boolean,
    required: false,
    default: false,
  },
  isEditActionTable: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emit = defineEmits([
  "update:data",
  "is-check-list-step",
  "check-validation",
]);

const title = ref("");
const description = ref("");
const optional = ref(false);
const idItemExpand: any = ref(null);
const arraySteps = ref(props.action.arraySteps || []);
const listSteps: any = ref([]);
const listSrepRemove: any = ref([]);
const detailSteps = ref<typeof props.action.detailSteps>(
  props.action.detailSteps || [],
);
const checklistId = computed(() => {
  return store.state.Recommend.checklistReportId;
});
watch(
  () => props.action,
  () => {
    arraySteps.value = props.action.arraySteps || [];
    detailSteps.value = props.action.detailSteps || [];
  },
);

watch(listSteps, (value) => {
  emit("is-check-list-step", value.length === 0);
});

const changeExpand = (id) => {
  idItemExpand.value = id;
};
const getStepToSolve = async (checklistId, checklistGroupId) => {
  try {
    const res = await getDataChecklistGroupAction(
      checklistId,
      checklistGroupId,
    );
    res.data.data.checklistGroups[0]?.checklistGroupActions.forEach((item) => {
      item.id = item.checklistGroupActionId;
      item.checklistGroupActionHtml = unescape(item.checklistGroupActionHtml);
    });
    listSteps.value =
      res.data.data.checklistGroups[0]?.checklistGroupActions.filter(
        (item) => !item.checklistGroupActionIsArchived,
      );
    listSteps.value.sort(
      (a, b) => a.checklistGroupActionOrder - b.checklistGroupActionOrder,
    );
    store.commit("Recommend/SET_LIST_STEP_ACTIONS_PLAN", listSteps.value);
  } catch (error: any) {
    listSteps.value = [];
    showErrorAPI(error, Checklist.getChecklistGroupAction);
  }
};
const getStepToSolveSuggesAction = async (groupTemplateId) => {
  try {
    const res = await getDataChecklistGroupTemplateAction(groupTemplateId);
    if (res.data.data.groupTemplates[0]?.groupTemplateActions) {
      res.data.data.groupTemplates[0]?.groupTemplateActions.forEach((item) => {
        item.checklistGroupActionHtml = unescape(item.groupTemplateActionHtml);
        item.checklistGroupActionName = item.groupTemplateActionName;
        item.checklistGroupActionOrder = item.groupTemplateActionOrder;
        item.id = item.groupTemplateActionId;
        item.checklistGroupActionImages = item.groupTemplateActionImages.map(
          (image) => {
            return {
              checklistGroupActionImageFile: image.groupTemplateActionImageFile,
            };
          },
        );
      });
      listSteps.value = res.data.data.groupTemplates[0]?.groupTemplateActions;
      listSteps.value.sort(
        (a, b) => a.checklistGroupActionOrder - b.checklistGroupActionOrder,
      );
    }
  } catch (error: any) {
    listSteps.value = [];
    showErrorAPI(error, Checklist.getChecklistGroupTemplateAction);
  }
};
onMounted(() => {
  if (props.inModalAdd) {
    // getStepToSolve();
  } else if (props.checkListGroupId || props.action.checklistGroupId) {
    getStepToSolve(
      checklistId.value,
      props.checkListGroupId || props.action.checklistGroupId,
    );
  } else if (
    props.checkListGroupTemplateId ||
    props.action.checklistGroupTemplateId
  ) {
    getStepToSolveSuggesAction(
      props.checkListGroupTemplateId || props.action.checklistGroupTemplateId,
    );
  }
});
const removeStep = (index) => {
  store.commit("Recommend/SET_LIST_STEP_REMOVED", listSteps.value[index]);
  listSteps.value.splice(index, 1);
  store.commit("Recommend/SET_LIST_STEP_ACTIONS_PLAN", listSteps.value);
};
const changeItem = (event) => {
  const checklistOrderOld =
    listSteps.value[event.moved.oldIndex].checklistGroupActionOrder;
  const checklistOrderNew =
    listSteps.value[event.moved.newIndex].checklistGroupActionOrder;
  listSteps.value[event.moved.oldIndex].checklistGroupActionOrder =
    checklistOrderNew;
  listSteps.value[event.moved.newIndex].checklistGroupActionOrder =
    checklistOrderOld;
  listSteps.value.forEach((item, index) => {
    item.checklistGroupActionOrder = index + 1;
  });
  store.commit("Recommend/SET_LIST_STEP_ACTIONS_PLAN", listSteps.value);
};
const handleUpdateData = (data, index) => {
  listSteps.value[index] = data;
  store.commit("Recommend/SET_LIST_STEP_ACTIONS_PLAN", listSteps.value);
  emit("update:data", data);
};
const addStep = () => {
  let id = 0;
  let checklistGroupActionOrder = 0;
  if (listSteps.value.length === 0) {
    id = 0;
    checklistGroupActionOrder = 0;
  } else {
    id = listSteps.value.reduce((max, item) => {
      return item.id > max ? item.id : max;
    }, listSteps.value[0].id);
    checklistGroupActionOrder = listSteps.value.reduce((max, item) => {
      return item.checklistGroupActionOrder > max
        ? item.checklistGroupActionOrder
        : max;
    }, listSteps.value[0].checklistGroupActionOrder);
  }
  title.value = "";
  description.value = "";
  optional.value = false;
  idItemExpand.value = id + 1;
  listSteps.value.push({
    id: id + 1,
    title: "",
    checklistGroupActionHtml: "",
    optional: false,
    checklistGroupActionOrder: checklistGroupActionOrder + 1,
  });
  store.commit("Recommend/SET_LIST_STEP_ACTIONS_PLAN", listSteps.value);
};
</script>

<style lang="scss" scoped>
.step__to__solve__in__modal .step {
  background-color: rgba(239, 240, 241, 0.5);
  border: 1px solid #eff0f1;
}
/* .step__to__solve__in__modal .step__content {
  height: 62px;
} */
.step__to__solve__in__modal .content {
  margin: 0px 10px;
  white-space: nowrap;
}
.step__to__solve__out__modal .content {
  margin-right: 12px;
}
.step__to__solve__out__modal .step {
  background-color: #fcfcfd;
  border: 1px solid #eff0f1;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05);
}
.step-title {
  font-family: Poppins, sans-serif;
}
.detail {
  border-top: 1px solid #eff0f1;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.title-detail-step {
  font-family: Poppins, sans-serif;
}
.sub-title-detail-step {
  font-family: Poppins, sans-serif;
}
.arrow-up {
  transform: rotate(180deg);
}
.arrow-down {
  transform: rotate(0deg);
}
@media only screen and (min-width: 1024px) {
  .step__to__solve__in__modal .step__content {
    height: 62px;
  }
}
.modal-edit-action-step-input {
  margin: 0 !important;
  justify-content: space-between;
  & > div:first-of-type {
    padding: 5px 0;
    flex: 0 0 30%;
  }
  & > div:last-of-type {
    max-width: 520px;
    min-width: 520px;
    padding: 0 !important;
    @media screen and (max-width: 550px) {
      min-width: 0;
    }
  }
}
</style>
